import { motion } from "framer-motion";
import PortfolioSection from "../components/HomeSectionContainers/PortfolioSection";
import ProductsSection from "../components/HomeSectionContainers/ProductsSection";
import AboutSection from "../components/HomeSectionContainers/AboutSection";
import ContactUsSection from "../components/HomeSectionContainers/ContactUsSectoin";
import HomeHeroSection from "../components/HomeSectionContainers/HomeHeroSection";
import colors from "../styles/colors";
import { useEffect } from "react";
import TitleSection from "../components/HomeSectionContainers/HomeTitleSection";
import { useTranslation } from "react-i18next";
import SEO from "../utils/SEO";

const Home = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <div
      className="w-full min-h-screen"
      style={{ backgroundColor: colors.pastelCream }}
    >
      {/* SEO meta tags */}
      <SEO
        title={t("seo_meta.home.metaTitle")}
        description={t("seo_meta.home.metaDescription")}
      />

      {/* Hero Section */}
      <HomeHeroSection />

      {/*Title section*/}
      <TitleSection />

      {/* Description: image + text */}
      <div
        className="w-full min-h-[50vh] p-4 md:p-8 flex flex-col lg:flex-row items-center justify-center lg:items-center lg:justify-center text-center lg:text-left gap-16 lg:gap-20"
        style={{ backgroundColor: colors.pastelCream }}
      >
        {/* Image */}
        <motion.img
          src="/assets/images/home/home_description.webp"
          alt={t("image_alt.home_desc")}
          loading="lazy"
          className="w-auto sm:w-3/4 md:w-3/4 lg:w-1/2 h-auto object-cover rounded-xl shadow-xl"
          initial={{ opacity: 0 }}
          whileInView={{
            opacity: 1,
            transition: { delay: 0.2, duration: 0.8 },
          }}
          viewport={{ once: false, amount: 0.2 }}
        />

        {/* Description */}
        <motion.p
          className="w-[90%] sm:w-3/4 md:w-2/3 lg:w-1/2 max-w-[90%] lg:max-w-lg lg:text-2xl text-lg md:text-xl font-serif"
          style={{ color: colors.darkBrown }}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: { delay: 0.2, duration: 0.5 },
          }}
          viewport={{ once: true, amount: 0.5 }}
        >
          {t("homeDescription")}
        </motion.p>
      </div>
      {/* Horizontal Divider */}
      <div
        className="w-full max-h-[20vh] pt-24 pb-24 flex justify-center"
        style={{ backgroundColor: colors.pastelCream }}
      >
        <hr
          className="w-[23%] sm:w-[15%] md:w-[15%] lg:w-[10%] h-0.5 border-t-0 opacity-100 dark:opacity-80"
          style={{ backgroundColor: colors.darkBrown }}
        />
      </div>

      {/* Portfolio Section */}
      <PortfolioSection />

      {/* Horizontal Divider */}
      <div
        className="w-full max-h-[20vh] pt-24 pb-24 flex justify-center"
        style={{ backgroundColor: colors.pastelCream }}
      >
        <hr
          className="w-[23%] sm:w-[15%] md:w-[15%] lg:w-[10%] h-0.5 border-t-0 opacity-100 dark:opacity-80"
          style={{ backgroundColor: colors.darkBrown }}
        />
      </div>

      {/* Products Section */}
      <ProductsSection />

      {/* About Us Section */}
      <AboutSection />

      {/* Contact Section */}
      <ContactUsSection />
    </div>
  );
};

export default Home;
